export const ROOT_URL = document.URL.startsWith('http://localhost') ? `http://localhost:8000/` : 'http://admin.kcntaybachoxa.com.vn/';
// export const ROOT_URL = `http://127.0.0.1:8000/`;